<template>
  <div style="margin: 0 0 12px;">
    <div>
      <el-input type="textarea" :rows="8" v-model="pageDesc" placeholder="请输入页面描述" style="width: 100%; flex: 1"/>
      <p style="font-size: 12px; margin-top: 8px; color: #aaaaaa">*编辑之后需要重新登陆才生效</p>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {pdateMenuPageDesc} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      pageDesc: this.value.pageDesc,
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      // if(!this.remarkForm.remark) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入价格',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}
      param['id'] = this.id
      param['pageDesc'] = this.pageDesc
      postFormData(pdateMenuPageDesc, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },






  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
